/**
 * AIAssistantContext — exposes the LIVI chat panel's open/close
 * state and a helper to programmatically open the panel pre-selected to
 * a specific chat session.
 *
 * Provided by AppShell (the only component that owns the chat panel
 * state). Consumed by descendants like the dashboard's "Pending HIL
 * Reviews" card, which needs to request "open chat AND select session
 * X" in one click.
 *
 * Shape:
 *   {
 *     canUseAIAssistant: boolean,   // user has access to the chat panel at all
 *     canResolveHIL: boolean,       // user has permission to address HIL sessions
 *     isChatOpen: boolean,
 *     openChatSession: (sessionId?: string, options?) => void,  // opens panel; if id given, switches to it
 *     toggleChat: () => void,
 *     clearCenterPanelOverride: () => void,  // clears any agent-rendered panel back to the route's default
 *   }
 *
 * If consumed outside an AppShell tree the context falls through to a
 * no-op default so callsites don't have to null-check the helper.
 */

import { createContext } from 'react';

export const AIAssistantContext = createContext({
  canUseAIAssistant: false,
  canResolveHIL: false,
  isChatOpen: false,
  openChatSession: () => {},
  toggleChat: () => {},
  clearCenterPanelOverride: () => {},
});

export default AIAssistantContext;
